/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum BusinessTripOrganizationType {
    CENTRAL = 'CENTRAL',
    DECENTRAL = 'DECENTRAL',
    OTHER = 'OTHER',
}
